<template>
  <el-tooltip manual :value="tooltipVisible" :disabled="!truncated" :content="label"
    :tabindex="-1" :enterable="false" placement="right" effect="dark">
    <span class="personal-menu-label">{{ label }}</span>
  </el-tooltip>
</template>

<script>
/** 单行菜单显示；完整原文保留在DOM，只有实际截断时才在悬停或菜单行聚焦时显示提示。 */
export default {
  name: "PersonalMenuLabel",
  props: { label: { type: String, default: "" } },
  data() { return { truncated: false, hovered: false, focused: false, tooltipVisible: false, dismissed: false }; },
  watch: { label() { this.$nextTick(this.measure); } },
  mounted() {
    this.menuRow = this.$el.closest(".el-menu-item, .el-submenu__title");
    this.focusRow = this.menuRow?.closest('[role="menuitem"]');
    this.rowListeners = [
      [this.menuRow, "mouseenter", this.enter], [this.menuRow, "mouseleave", this.leave],
      [this.focusRow, "focusin", this.focus], [this.focusRow, "focusout", this.blur],
      [this.focusRow, "keydown", this.keydown],
    ];
    this.rowListeners.forEach(([row, event, handler]) => row?.addEventListener(event, handler));
    if (typeof ResizeObserver !== "undefined") {
      this.labelObserver = new ResizeObserver(this.measure);
      this.labelObserver.observe(this.$el);
    }
    this.measure();
  },
  beforeDestroy() {
    this.labelObserver?.disconnect();
    (this.rowListeners || []).forEach(([row, event, handler]) => row?.removeEventListener(event, handler));
  },
  methods: {
    /** 只在文字、可用宽度或交互状态变化时测量，不创建逐帧监听。 */
    measure() {
      this.truncated = this.$el.scrollWidth > this.$el.clientWidth + 1;
      this.tooltipVisible = this.truncated && !this.dismissed && (this.hovered || this.focused);
    },
    enter() { this.hovered = true; this.dismissed = false; this.measure(); },
    leave() { this.hovered = false; this.measure(); },
    focus(event) {
      if (event.target !== this.focusRow) return;
      this.focused = true; this.dismissed = false; this.measure();
    },
    blur(event) {
      if (event.target !== this.focusRow) return;
      this.focused = false; this.measure();
    },
    keydown(event) {
      if (event.target === this.focusRow && event.key === "Escape") {
        this.dismissed = true; this.tooltipVisible = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
.personal-menu-label {
  display: block;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
